import { ShiftRequestPayload } from '@app/core/async-services/http/versioned/interfaces/scheduler.interface';
import { createAction, props } from '@ngrx/store';

export const getShiftSwapApprovalDataSucceeded = createAction(
  '[Shift Swap Approval] Get Shift Swap Approval Data Succeeded',
  props<{ payload: ShiftRequestPayload }>(),
);

export const shiftSwapApprovalPageInitialized = createAction(
  '[Shift Swap Approval] Page Initialized',
);

export const shiftSwapApprovalPageRefreshed = createAction(
  '[Shift Swap Approval] Page Refreshed',
  props<{ entId: string; fromDate: string; toDate: string }>(),
);

export const pendingSwapClicked = createAction(
  '[Shift Swap Approval] Pending Swap Clicked',
  props<{ id: string }>(),
);

export const pendingOfferClicked = createAction(
  '[Shift Swap Approval] Pending Offer Clicked',
  props<{ id: string }>(),
);

export const shiftRequestDetailsPageInitialized = createAction(
  '[Shift Request Details] Page Initialized',
);

export const menuInitialized = createAction(
  '[Shift Swap Requests] Menu Initialized',
  props<{ entId: string; fromDate: string; toDate: string }>(),
);

export const menuSaved = createAction(
  '[Shift Swap Requests] Menu Saved',
  props<{ entId: string; fromDate: string; toDate: string }>(),
);

export const denySwapClicked = createAction(
  '[Shift Request Details] Deny Swap Clicked',
  props<{ notes: string; responseId: string }>(),
);

export const approveSwapClicked = createAction(
  '[Shift Request Details] Approve Swap Clicked',
  props<{ notes: string; responseId: string }>(),
);

export const denyOfferClicked = createAction(
  '[Shift Request Details] Deny Offer Clicked',
  props<{ notes: string; responseId: string }>(),
);

export const approveOfferClicked = createAction(
  '[Shift Request Details] Approve Offer Clicked',
  props<{ notes: string; responseId: string }>(),
);

export const shiftRequestApprovalSucceeded = createAction(
  '[Shift Request Details] Request Approval Succeeded',
  props<{ entId: string; fromDate: string; toDate: string }>(),
);

export const shiftRequestDenialSucceeded = createAction(
  '[Shift Request Details] Request Denial Succeeded',
  props<{ entId: string; fromDate: string; toDate: string }>(),
);

export const shiftRequestApprovalFailed = createAction(
  '[Shift Request Details] Request Approval Failed',
  props<{ message: string }>(),
);

export const shiftRequestDenialFailed = createAction(
  '[Shift Request Details] Request Denial Failed',
  props<{ message: string }>(),
);

export const shiftSwapApprovalPageDestroyed = createAction(
  '[Shift Swap Approval] Page Destroyed',
);
